var React = require('react');

function WaveOverlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0103231 48.9253C0.0103231 48.9253 286.058 144.707 719.63 43.597C1153.2 -57.5133 1440 48.9254 1440 48.9254L1440 95L5.273e-05 94.9999L0.0103231 48.9253Z","fill":"white"}));
}

WaveOverlayInline.defaultProps = {"width":"1440","height":"95","viewBox":"0 0 1440 95","fill":"none"};

module.exports = WaveOverlayInline;

WaveOverlayInline.default = WaveOverlayInline;
